import React from "react";
import { VhModal } from "msd";
import { Row } from "antd";
import { LOGIN_URL, TOKEN, CID, ERROR_MESSAGE, DOMAIN } from "common/constants";

let errList: string[] = [];
let errModal: any;

const codeMessage: {[key: number]: string} = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。",
};

const checkStatus = (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  console.error(`请求错误 ${response.status}: ${response.url}`);
  console.error(`${errortext}`);
  const error: any = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
};

export default function fetchApi(method: "get" | "post" | "put" | "delete", url: string, data?: any) {
  let hideError = false;
  const token = TOKEN;
  const cId = CID;

  // 断网情况check
  if (!navigator.onLine) {
    VhModal.error({content: "网络原因，请检查网络后继续！"});
    return;
  }

  // 是否不处理error
  if (data && data.hideError === true) {
    hideError = true;
    delete data.hideError;
  }

  // header设置
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json; charset=utf-8",
    "Authorization": "Bearer " + token,
    "Mscid": cId,
    "Domain":DOMAIN
  };

  // CID和token check
  if (!token) {
    delete headers.Authorization;
  }
  if (!cId) {
    delete headers.Mscid;
  }

  // 非微知公司判断
  if (cId !== "288572") {
    console.log("cid非288572")
    const errModal = VhModal.error({
      content: "登录已失效，请重新登录",
      onOk: () => {
        fetch("home-server/auth/logout", {
          method: "get",
          headers: {...headers}
        });
        window.location.href = LOGIN_URL;
      }
    });
    return;
  }

  // 发出请求
  return fetch("/" + url, {
    method,
    credentials: "include",
    headers: {...headers},
    body: method === "post" ? (data && JSON.stringify(data)) : undefined
  })
  .then(checkStatus)
  .then(response => {
    // DELETE and 204 do not return data by default
    // using .json will report an error.
    if (method === "delete" || response.status === 204) {
      return response.text();
    }
    return response.json();
  })
  .then(value => {
    if (value.result === 401) {
      console.log("错误信息：",value);
      const errModal = VhModal.error({
        content: value.detail || ERROR_MESSAGE,
        onOk: () => {
          fetch("home-server/auth/logout", {
            method: "get",
            headers: {...headers}
          });
          window.location.href = LOGIN_URL;
        }
      });
    }
    else if (value.result !== 0 && !hideError) {
      const msg = value.detail || ERROR_MESSAGE;
      // 错误信息不同，则添加入错误列表
      if (!errList.includes(msg)) {
        errList.push(msg);
      }

      // 只存在一个错误弹框
      if (!errModal) {
        errModal = VhModal.error({
          content: errList.map((item: string, i: number) => React.createElement(Row, {key: String(i)}, item)),
          onOk: () => {
            // 初始化错误数据
            errList = [];
            errModal = undefined;

            // 用户停用状态check
            if (value.result === 402) {
              fetch("home-server/auth/logout", {
                method: "get",
                headers: {...headers}
              });
              window.location.href = LOGIN_URL;
            }
          }
        });
      } else {
        errModal.update({
          content: errList.map((item: string, i: number) => React.createElement(Row, {key: String(i)}, item))
        })
      }
    }
    else {
      return value;
    }
  })
  .catch(e => {
    return e;
  });
}
